import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  initializeZodI18n,
  registerUITranslations,
  UI_I18N_NAMESPACES
} from '@repo/ui/i18n'

import common from './locales/de/common.json'
import befehle from './locales/de/befehle.json'
import standorteingabe from './locales/de/standorteingabe.json'
import bfn from './locales/de/bfn.json'
import bfnDetails from './locales/de/bfnDetails.json'
import bfnOverview from './locales/de/bfnOverview.json'
import acceptPrivacyPolicy from './locales/de/acceptPrivacyPolicy.json'
import init from './locales/de/init.json'
import errorpage from './locales/de/errorpage.json'

const appResources = {
  de: {
    common,
    befehle,
    standorteingabe,
    bfn,
    bfnDetails,
    bfnOverview,
    acceptPrivacyPolicy,
    init,
    errorpage
  }
}

const APP_I18N_NAMESPACES = [
  'common',
  'befehle',
  'standorteingabe',
  'bfn',
  'bfnDetails',
  'bfnOverview',
  'acceptPrivacyPolicy',
  'init',
  'errorpage'
] as const

// eslint-disable-next-line import-x/no-named-as-default-member
i18next.use(initReactI18next).init({
  lng: 'de',
  fallbackLng: 'de',
  ns: [...APP_I18N_NAMESPACES, ...UI_I18N_NAMESPACES],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
  react: {
    useSuspense: false
  },
  returnNull: false
})

// Register app translations
for (const [lng, namespaces] of Object.entries(appResources)) {
  for (const [ns, translations] of Object.entries(namespaces)) {
    i18next.addResourceBundle(lng, ns, translations, true, false)
  }
}

// Register UI translations
registerUITranslations(i18next)

// Initialize Zod i18n error messages
initializeZodI18n()

export default i18next
